export default __webpack_public_path__ + "static/3_20-0f3d5f12e231030b61c30b9134e89c06.png";